import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="event-row"
// Handles clicking on event table rows to navigate to event details
export default class extends Controller {
  static values = {
    eventId: Number
  }
  
  connect() {
    // Get event ID from data attribute if not in value
    if (!this.hasEventIdValue) {
      this.eventIdValue = parseInt(this.element.dataset.eventId)
    }
  }
  
  showEvent(event) {
    
    // Don't navigate if clicking on buttons, links, or form elements
    if (event.target.closest('button, a, .dropdown-menu, .dropdown-toggle, form, input, select, textarea')) {
      return
    }
    
    // Navigate to event show page
    const eventId = this.eventIdValue || this.element.dataset.eventId
    
    if (eventId) {
      window.location.href = `/events/${eventId}`
    }
  }
}

